import styled from 'styled-components';

export const AISummaryContainer = styled.div`
  width: 100%;
  background: #f5f5f5;
  padding: 14px 16px;
  position: relative;
  margin: 2px 0 16px;
`;

export const AISummaryTitle = styled.span`
  font-size: 14px;
  color: #202020;
  font-weight: bold;
  vertical-align: middle;
  padding-left: 8px;
`;

export const AISummaryContent = styled.div`
  padding-left: 24px;
  padding-top: 10px;
`;

export const AISummaryContentMain = styled.div`
  display: flex;
  flex-direction: column;
`;
